import React from "react";
import { Switch, Route, RouteProps } from "react-router-dom";

import { routes_commons } from "./path";

export default function RoutingContents() {
  return (
    <React.Fragment>
      <Switch>
        {routes_commons.map((route, id) => (
          <CommonRoute {...route} key={`commonRoute${id}`} />
        ))}
        <Route path="/*" />
      </Switch>
    </React.Fragment>
  );
}

export const CommonRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  return (
    <React.Suspense fallback={<></>}>
      <Route {...rest} />
    </React.Suspense>
  );
};
